import { Injectable } from '@angular/core';
declare var THREE: any;
import { StageService } from './stage.service';
import { SizeHelperService } from './size-helper.service';
import { ConstantsService } from './constants.service';
import { BuildingCheckerService } from './building-checker.service';
import { ModelLoaderService } from './model-loader.service';
import { SetMaterialsService } from './set-materials.service';
import { LoadingSpinnerService } from './loading-spinner.service';

@Injectable()
export class StairLandingStraightService{

  private intermediateStair: any;
  private landing: any;
  private stairsPositions: any = [];
  private angle: any;
  private norm: any;

  constructor(
    private stage: StageService,
    private sizeHelper: SizeHelperService,
    private constants: ConstantsService,
    private buildingCheckerService: BuildingCheckerService,
    private modelLoaderService: ModelLoaderService,
    private setMaterialsService: SetMaterialsService,
    private loadingSpinnerService: LoadingSpinnerService
  ) { }

  build(config): Promise<any> {
    let intermediateStepPromise = this.modelLoaderService.loadLocalModel('Intermediate_step');
    let landingPromise = this.modelLoaderService.loadLocalModel('Landing');
    let promises = [intermediateStepPromise, landingPromise];
    this.loadingSpinnerService.spinnerLoadingListAdd('StairLandingStraightService');
    return Promise.all(promises)
      .then(res => {
        this.loadingSpinnerService.spinnerLoadingListRemove('StairLandingStraightService');
        this.intermediateStair = res[0];
        this.landing = res[1];
        if (config.superstructureId) {
          let A = config.firstPoint;
          let B = config.secondPoint;
          let AB = new THREE.Vector3(B.x - A.x, 0, B.y - A.y);
          // so stair don't built outside edge
          if (config.distance > AB.length() - config.width / 2 - this.constants.minimalSpaceForStairsOnSIde) {
            config.distance = AB.length() - config.width / 2 - this.constants.minimalSpaceForStairsOnSIde;
          }
          // remove stair if not enought space on edge
          if (config.width + this.constants.minimalSpaceForStairsOnSIde * 2 > AB.length()) {
            config.firstPoint.superstructureType = null;
            config.firstPoint.distance = null;
            config.firstPoint.superstructureId = null;
            config.firstPoint.floorId = null;
            return;
          }
        }
        this.setPositionsForStairs(config);
        const stairs = this.addStairs(config);

        this.setMaterialsService.setMaterialForStairs();
        return stairs;
      });
  }

  setPositionsForStairs(config) {
    let height = config.height;

    let A = config.firstPoint;
    let B = config.secondPoint;
    let rot: any = false;
    if (A.x >= B.x - 0.05 && A.x <= B.x + 0.05 && A.y > B.y) {
      rot = Math.PI * 3 / 2;
    }

    let AB = new THREE.Vector3(B.x - A.x, 0, B.y - A.y);
    let norm = new THREE.Vector3(AB.z, 0, -AB.x);

    let norm2 = norm.clone();
    let stairHeight = this.sizeHelper.INCHToCM(7);

    let down = new THREE.Vector3(0, -stairHeight, 0);
    let countIntermediateStairs = Math.floor(height / stairHeight);

    this.stairsPositions = [];
    let firstPosition = new THREE.Vector3(A.x, height, A.y);
    AB.setLength(config.distance);
    firstPosition.add(AB);

    for (let i = 0; i < countIntermediateStairs; i++) {
      this.stairsPositions[i] = new THREE.Vector3(firstPosition.x, height, firstPosition.z);

      norm.setLength(this.sizeHelper.INCHToCM(9));
      norm2.setLength(norm.length() / 2);
      this.stairsPositions[i].add(norm2);
      if (i !== countIntermediateStairs) {
        this.stairsPositions[i].add(down);

      }
      for (let j = 0; j < i; j++) {
        this.stairsPositions[i].add(norm);
        this.stairsPositions[i].add(down);
      }
    }

    norm.setLength(53.34 - 14);
    down.setLength(1);
    this.stairsPositions[countIntermediateStairs - 1].add(norm);
    this.stairsPositions[countIntermediateStairs - 1].add(down);


    var med = new THREE.Vector3(B.x - A.x, 0, B.y - A.y);
    med.setLength(1);
    this.norm = med;

    if (rot) {
      this.norm.rot = rot;
    }

    var nullVec = new THREE.Vector3(-1, 0, 0);
    this.angle = med.angleTo(nullVec);

    if (med.x * nullVec.x + med.z * nullVec.z <= 0 && med.x * nullVec.z - med.z * nullVec.x < 0) {
      this.angle += Math.PI;
    }
  }

  addStairs(config) {
    let stairs = new THREE.Object3D();
    const superstructureId = config.superstructureId || stairs.id;
    stairs.userData.type = "LandingStraight";
    // stairs.position.set(this.stairsPositions[0].x, this.stairsPositions[0].y, this.stairsPositions[0].z);
    stairs.name = 'stairs';
    stairs.userData.name = 'stairs';
    this.stage.add(stairs);

    stairs.userData.config = config;
    stairs.userData.config.superstructureType = 'stairLandingStraight';
    stairs.userData.config.superstructureId = superstructureId;

    config.firstPoint.distance = config.distance;
    config.firstPoint.superstructureType = 'stairLandingStraight';
    config.firstPoint.superstructureId = superstructureId;

    config.firstPoint.width = config.width;
    config.firstPoint.stairs = true;
    config.firstPoint.superstructure = stairs;

    for (let i = 0; i < this.stairsPositions.length - 1; i++) {
      let obj = this.intermediateStair.clone();
      obj.userData.isDeckComponent = true;
      obj.userData.isChildStep = true;
      obj.position.set(this.stairsPositions[i].x, this.stairsPositions[i].y - 34.867 / 2, this.stairsPositions[i].z);;
      obj.rotation.y = this.angle;

      let dir = obj.getWorldDirection(new THREE.Vector3());

      for (let j = 0; j < 4; j++) {
        let x = this.norm.x * dir.z - this.norm.z * dir.x;
        if (!(this.norm.x * dir.z - this.norm.z * dir.x > -0.05 && this.norm.x * dir.z - this.norm.z * dir.x < 0.05 && this.norm.x > -dir.x - 0.05 && this.norm.x < -dir.x + 0.05)) {
          obj.rotation.y += Math.PI / 2;
          dir = obj.getWorldDirection(new THREE.Vector3());
        }
      }

      let x = this.norm.x * dir.z - this.norm.z * dir.x;
      if (!(this.norm.x * dir.z - this.norm.z * dir.x > -0.05 && this.norm.x * dir.z - this.norm.z * dir.x < 0.05 && this.norm.x > -dir.x - 0.05 && this.norm.x < -dir.x + 0.05)) {
        obj.rotation.y = - obj.rotation.y;
        dir = obj.getWorldDirection(new THREE.Vector3());
      }

      for (let j = 0; j < 6; j++) {
        let x = this.norm.x * dir.z - this.norm.z * dir.x;
        if (!(this.norm.x * dir.z - this.norm.z * dir.x > -0.05 && this.norm.x * dir.z - this.norm.z * dir.x < 0.05 && this.norm.x > -dir.x - 0.05 && this.norm.x < -dir.x + 0.05)) {
          obj.rotation.y += Math.PI / 2;
          dir = obj.getWorldDirection(new THREE.Vector3());
        }
      }

      obj.rotation.y -= Math.PI / 2;
      if (this.norm.rot) {
        obj.rotation.y = this.norm.rot;
      }

      if (i == 0) {
        obj.name = "Top";
      }

      if (i == this.stairsPositions.length - 2) {
        obj.name = "Bottom";
      }

      this.stage.add(obj);

      THREE.SceneUtils.attach(obj, this.stage.getScene(), stairs);
    }
    let i = this.stairsPositions.length - 1;
    let obj = this.landing.clone();
    obj.userData.isDeckComponent = true;
    obj.userData.isChildStep = true;
    obj.position.set(this.stairsPositions[i].x, this.stairsPositions[i].y - 17.16 / 2, this.stairsPositions[i].z);;
    obj.rotation.y = this.angle;

    let dir = obj.getWorldDirection(new THREE.Vector3());

    for (let j = 0; j < 4; j++) {
      let x = this.norm.x * dir.z - this.norm.z * dir.x;
      if (!(this.norm.x * dir.z - this.norm.z * dir.x > -0.05 && this.norm.x * dir.z - this.norm.z * dir.x < 0.05 && this.norm.x > -dir.x - 0.05 && this.norm.x < -dir.x + 0.05)) {
        obj.rotation.y += Math.PI / 2;
        dir = obj.getWorldDirection(new THREE.Vector3());
      }
    }

    let x = this.norm.x * dir.z - this.norm.z * dir.x;
    if (!(this.norm.x * dir.z - this.norm.z * dir.x > -0.05 && this.norm.x * dir.z - this.norm.z * dir.x < 0.05 && this.norm.x > -dir.x - 0.05 && this.norm.x < -dir.x + 0.05)) {
      obj.rotation.y = - obj.rotation.y;
      dir = obj.getWorldDirection(new THREE.Vector3());
    }

    for (let j = 0; j < 6; j++) {
      let x = this.norm.x * dir.z - this.norm.z * dir.x;
      if (!(this.norm.x * dir.z - this.norm.z * dir.x > -0.05 && this.norm.x * dir.z - this.norm.z * dir.x < 0.05 && this.norm.x > -dir.x - 0.05 && this.norm.x < -dir.x + 0.05)) {
        obj.rotation.y += Math.PI / 2;
        dir = obj.getWorldDirection(new THREE.Vector3());
      }
    }

    obj.rotation.y -= Math.PI / 2;
    if (this.norm.rot) {
      obj.rotation.y = this.norm.rot;
    }

    obj.name = "Landing";

    this.stage.add(obj);
    THREE.SceneUtils.attach(obj, this.stage.getScene(), stairs);
    let floor = this.stage.getFloorById(config.floorId);
    THREE.SceneUtils.attach(stairs, this.stage.getScene(), floor);
    return stairs;
  }

  rescaleStairs(): void {
    let stairs = this.stage.getStairs().filter(obj =>
      obj.userData.config.superstructureType === 'stairLandingStraight');
    for (let i = 0; i < stairs.length; i++) {

      if (this.buildingCheckerService.checkHeightForStairs('stairLandingStraight', stairs[i].parent.getWorldPosition(new THREE.Vector3()).y)) {
        stairs[i].userData.config.height = stairs[i].parent.getWorldPosition(new THREE.Vector3()).y;
        stairs[i].parent.remove(stairs[i]);
        this.build(stairs[i].userData.config);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/services/stair-landing-straight.service.ts